module.exports = __webpack_public_path__ + "static/media/plus.283d1977.svg";